import { useEffect } from "react";
import LockIcon from "@mui/icons-material/Lock";
import useCheckCompatibility from "../../../hooks/useCheckCompatibility";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

const customStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "0.5rem",
    color: "rgba(111, 117, 138, 1)",
    fontSize: "14px",
    lineHeight: "2rem",
    fontWeight: "bold",
    "& span": {
      width: "85%",
      whiteSpace: "break-spaces",
    },
  },
};

const authToken = localStorage.getItem("abjadToken");

function NotCompatible() {
  const navigate = useNavigate();
  const isNotCompatible = useCheckCompatibility();
  const { t } = useTranslation();

  useEffect(() => {
    if (isNotCompatible) navigate("/device-not-compatible");
    else if (authToken) navigate("/teachers-reports");
    else navigate("/login");
  }, []);

  return (
    <Typography component="div" sx={customStyles.root}>
      <LockIcon style={{ fontSize: "5rem", padding: "1rem" }} />
      <span>{t("Not Compatible")}</span>
    </Typography>
  );
}

export default NotCompatible;
